import { styled } from "@mui/material/styles";
import WorkAgreement, { WorkAgreementFieldCategory } from "work/work-agreements/work-agreement";

const ComponentContainer = styled("div")(
  ({ theme }) => ({
    margin: theme.spacing(2, 0, 4, 0),
  }));

type InvoicesTabProps = {
  activeTab: WorkAgreementFieldCategory;
  workAgreement: WorkAgreement;
};

export default function InvoicesTab(props: Readonly<InvoicesTabProps>) {
  const {
    activeTab
  } = props;

  if (activeTab !== WorkAgreementFieldCategory.Invoices) return null;

  return (
    <ComponentContainer>
      <p>TODO</p>
    </ComponentContainer>
  );
}
